import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

export interface IDeleteTagDialogProps {
  tagName: string;
  onConfirm: () => void;
  trigger: React.ReactNode;
}

export function DeleteTagDialog({ tagName, onConfirm, trigger }: IDeleteTagDialogProps) {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger}
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-mono">Delete Tag</DialogTitle>
          <DialogDescription className="font-mono text-sm">
            Are you sure you want to delete <span className="font-bold">#{tagName}</span>?
            <br />
            <br />
            All locations will lose this tag association.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            onClick={() => setOpen(false)}
            className="bg-transparent text-muted-foreground hover:text-foreground border border-border rounded px-4 py-2 text-sm font-mono font-bold cursor-pointer transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:opacity-90 border-none rounded px-4 py-2 text-sm font-mono font-bold cursor-pointer transition-opacity"
          >
            Delete
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
